import script from "./TowerMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TowerMessage.vue?vue&type=script&setup=true&lang=ts"

import "./TowerMessage.vue?vue&type=style&index=0&id=4953e77e&lang=scss"

const __exports__ = script;

export default __exports__